import { render, staticRenderFns } from "./selfie.vue?vue&type=template&id=f473ebc6&scoped=true"
import script from "./selfie.vue?vue&type=script&lang=ts"
export * from "./selfie.vue?vue&type=script&lang=ts"
import style0 from "./selfie.vue?vue&type=style&index=0&id=f473ebc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f473ebc6",
  null
  
)

export default component.exports